import { render, staticRenderFns } from "./PlateNumberInputs.vue?vue&type=template&id=68bfbea2&scoped=true&"
import script from "./PlateNumberInputs.vue?vue&type=script&lang=js&"
export * from "./PlateNumberInputs.vue?vue&type=script&lang=js&"
import style0 from "./PlateNumberInputs.vue?vue&type=style&index=0&id=68bfbea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfbea2",
  null
  
)

export default component.exports